import API from 'services/api';

export const deleteiCal = ({
  iCalLinkId,
  deleteOccupancies = false,
}: {
  iCalLinkId: string;
  deleteOccupancies?: boolean;
}) =>
  API.delete(`/api/accommodation/iCal/${iCalLinkId}`, {
    params: {
      deleteOccupancies,
    },
  });
